<template>
  <Menu as="div" class="relative inline-block text-left">
    <div>
      <MenuButton
          class="inline-flex items-center px-2 py-0.5 border border-transparent text-sm font-medium rounded text-primary-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500">
        Действия
        <ChevronDownIcon class="-mr-1 pt-1 h-5 w-5" aria-hidden="true"/>
      </MenuButton>
    </div>

    <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
      <MenuItems
          class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none z-10">
        <div class="py-1">

          <MenuItem v-for="(item, index) in items" :key="item.key +'_'+ index" v-slot="{ active }">
            <hr v-if="item.br" class="w-full my-1"/>
            <button v-else type="button" class="w-full" @click="ok(item.key)"
                    :class="[active ? item.hoverClass : item.class, 'group flex items-center px-4 py-2 text-sm']">
              <component :is="item.icon" class="mr-3 h-5 w-5" :class="item.iconClass" aria-hidden="true"/>
              {{ item.label }}
            </button>
          </MenuItem>
        </div>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script>

const default_item = {
  key: '-',
  icon: 'HashtagIcon',
  iconClass: 'text-gray-400 group-hover:text-gray-500',
  label: '-',
  class: 'text-gray-700',
  hoverClass: 'bg-gray-100 text-gray-900',
}

const all = {
  'edit': {
    key: 'edit',
    icon: 'PencilAltIcon',
    iconClass: 'text-gray-400 group-hover:text-gray-500',
    label: 'Изменить',
    class: 'text-gray-700',
    hoverClass: 'bg-gray-100 text-gray-900',
    br: false
  },
  'add_parent': {
    key: 'add_parent',
    icon: 'UserAddIcon',
    iconClass: 'text-gray-400 group-hover:text-gray-500',
    label: 'Добавить родителя',
    class: 'text-gray-700',
    hoverClass: 'bg-gray-100 text-gray-900',
    br: false
  },
  'close': {
    key: 'close',
    icon: 'CheckCircleIcon',
    iconClass: 'text-gray-400 group-hover:text-gray-500',
    label: 'Закрыть',
    class: 'text-gray-700',
    hoverClass: 'bg-gray-100 text-gray-900',
    br: false
  },
  'duplicate': {
    key: 'duplicate',
    icon: 'DuplicateIcon',
    iconClass: 'text-gray-400 group-hover:text-gray-500',
    label: 'Дублировать',
    class: 'text-gray-700',
    hoverClass: 'bg-gray-100 text-gray-900',
    br: false
  },
  'remove': {
    key: 'remove',
    icon: 'TrashIcon',
    iconClass: 'text-red-400 group-hover:text-red-500',
    label: 'Удалить',
    class: 'text-red-700',
    hoverClass: 'bg-red-100 text-red-900',
    br: false
  },
  'publish': {
    key: 'publish',
    icon: 'EyeIcon',
    iconClass: 'text-gray-400 group-hover:text-gray-500',
    label: 'Опубликовать',
    class: 'text-gray-700',
    hoverClass: 'bg-gray-100 text-gray-900',
    br: false
  },
  'cancel_publish': {
    key: 'cancel_publish',
    icon: 'EyeOffIcon',
    iconClass: 'text-orange-400 group-hover:text-orange-500',
    label: 'Отменить публикацию',
    class: 'text-orange-700',
    hoverClass: 'bg-orange-100 text-orange-900',
    br: false
  },
  'exclude': {
    key: 'exclude',
    icon: 'ReceiptRefundIcon',
    iconClass: 'text-orange-400 group-hover:text-orange-500',
    label: 'Исключить',
    class: 'text-orange-700',
    hoverClass: 'bg-orange-100 text-orange-900',
    br: false
  },

}


import {Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/vue'
import {isString, merge} from "lodash";
import {
  ChevronDownIcon,
  DuplicateIcon,
  PencilAltIcon,
  TrashIcon,
  HashtagIcon,
  UsersIcon,
  UserCircleIcon,
  EyeIcon,
  EyeOffIcon
} from '@heroicons/vue/solid'

import {
  CheckCircleIcon,
  LockOpenIcon,
  AcademicCapIcon,
  ReceiptRefundIcon,
  UserAddIcon
} from '@heroicons/vue/outline'


export default {
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    ChevronDownIcon,
    PencilAltIcon,
    DuplicateIcon,
    TrashIcon,
    CheckCircleIcon,
    LockOpenIcon,
    AcademicCapIcon,
    ReceiptRefundIcon,
    HashtagIcon,
    UsersIcon,
    UserAddIcon,
    UserCircleIcon,
    EyeIcon,
    EyeOffIcon
  },
  emits: ['ok'],
  props: {
    actions: {
      type: Array,
      required: true,
    }
  },
  methods: {
    ok(key) {
      this.$emit('command', key)
      this.$emit('ok', key)
    }
  },
  data() {
    return {}
  },
  computed: {
    items() {
      return this.actions.map(item => {
            if (isString(item)) {
              if (item in all) return all[item]
              else return {br: true, key: 'br'};
            } else {
              return merge({}, default_item, item)
            }
          }
      )
    }
  }
}
</script>